<template>
  <div
    :class="type == 'inline' ? 'loading-inline' : 'loading-block'"
    :style="{
      height: $props.height,
    }"
  >
    <div class="loading_blob" :style="{ backgroundColor: color }"></div>
    <div class="loading_blob" :style="{ backgroundColor: color }"></div>
    <div class="loading_blob" :style="{ backgroundColor: color }"></div>
  </div>
</template>

<script>
export default {
  props: {
    color: { type: String, default: '#5e2bb8' },
    type: { type: String, default: 'inline' },
    height: { type: String, default: '2em' },
  },
  data() {
    return {}
  },
}
</script>
<style src="./style.scss" lang="scss" scoped></style>
